import React, { useState } from "react";
import { Link } from "react-router-dom";
import ITGuideModal from "../../components/it/ITGuideModal";



function PanelCard({ to, title, desc, icon, disabled = false }) {
  const base =
    "border p-4 rounded shadow-md border-gray-200 dark:border-neutral-700 bg-background-light dark:bg-neutral-900 transition";
  const active =
    "hover:shadow-lg hover:border-yellow-500 cursor-pointer";
  const inactive = "opacity-70";
  

  if (disabled) {
    return (
      <div className={`${base} ${inactive}`}>
        <h3 className="text-lg font-semibold text-primary-light">
          {icon} {title}
        </h3>
        <p className="text-sm text-text-light dark:text-text-dark">
          {desc}
        </p>
      </div>
    );
  }

  return (
    <Link to={to} className={`${base} ${active}`}>
      <h3 className="text-lg font-semibold text-primary-light">
        {icon} {title}
      </h3>
      <p className="text-sm text-text-light dark:text-text-dark">
        {desc}
      </p>
    </Link>
  );
}

export default function ITAdminPage() {

const [showGuide, setShowGuide] = useState(false);

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
  <div>
    <h1 className="text-2xl font-bold">IT Admin</h1>
    <p className="text-sm text-gray-500 mt-1">
      Central panel for access control, permissions, policies and visibility.
    </p>
  </div>

  <button
    onClick={() => setShowGuide(true)}
    className="px-4 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-black dark:text-white"
  >
    ℹ Guide
  </button>
</div>

      <div className="grid gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        
  <PanelCard
    to="/it/position-roles"
    icon="🧩"
    title="Position → Roles Mapping"
    desc="Assign access roles to organizational positions."
  />

  <PanelCard
    to="/it/hr-role-mappings"
    icon="👥"
    title="Role → Policy Mapping"
    desc="Map access roles to system policies. Roles are inherited from positions."
  />

  <PanelCard
    to="/it/policies"
    icon="🛡"
    title="Policies"
    desc="Review policy bundles and manage which permissions each policy includes."
  />

  <PanelCard
    to="/it/permissions"
    icon="🔑"
    title="Permissions"
    desc="Manage granular system permissions grouped by application modules."
  />

  <PanelCard
    to="/it/modules"
    icon="🧱"
    title="Modules"
    desc="Manage application modules used to organize permissions and visibility."
  />

  <PanelCard
    to="/it/scope-rules"
    icon="🌳"
    title="Scope Rules"
    desc="Define visibility scope by role, policy or user across modules."
  />

  <PanelCard
    to="/it/access/users"
    icon="🔐"
    title="Access Users"
    desc="Inspect users, linked HR persons, active positions and effective access results."
  />

  <PanelCard
    to="/it/access-preview"
    icon="🧪"
    title="My Access Debug"
    desc="See the effective access, roles, policies and permissions for the current user."
  />

  <PanelCard
    to="/it/audit"
    icon="📜"
    title="IT Audit"
    desc="Review audit logs for access, policy, permission and mapping changes."
  />

  <PanelCard
    to="/it/mail/accounts"
    icon="📬"
    title="Mail Access"
    desc="Manage mailbox accounts and assigned users."
  />

  <PanelCard
    to="/it/mail/signature-branding-defaults"
    icon="🎨"
    title="Signature Branding Defaults"
    desc="Manage default company logo, website, social links and signature branding values."
  />

  <PanelCard
    to="/it/mail/signature-templates"
    icon="✍️"
    title="Mail Signature Templates"
    desc="Manage corporate signature templates and generate for domain users."
  />

  <PanelCard
    to="/it/mail/signature-profiles"
    icon="👤"
    title="Mail Signature Profiles"
    desc="Manage user signature profile data and sync from HR."
  />

  <PanelCard
    to="/it/notifications"
    icon="🔔"
    title="Notification Control"
    desc="Monitor in-app notifications, escalations, push delivery and response metrics."
  />

      </div>
      <ITGuideModal open={showGuide} onClose={() => setShowGuide(false)} />
    </div>
    
  );
  
}